<div class="st-page">

  <!-- Header -->
  <header class="st-page__header">
    <div class="st-page__header-left">
      <div class="st-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="7" height="7" rx="1"/>
          <rect x="14" y="3" width="7" height="7" rx="1"/>
          <rect x="3" y="14" width="7" height="7" rx="1"/>
          <circle cx="17.5" cy="17.5" r="2.5"/>
        </svg>
      </div>
      <div>
        <h1 class="st-page__title">Structures</h1>
        <p class="st-page__desc">Gérez les structures de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter une structure"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddStructures()"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="st-card">
    @if (isLoading) {
      <div class="st-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="st-card__toolbar">
        <div class="st-card__toolbar-left">
          <span class="st-badge">{{ structures.length }}</span>
          <span class="st-card__count">
            structure{{ structures.length > 1 ? 's' : '' }}
            enregistrée{{ structures.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!structures.length) {
        <div class="st-empty">
          <div class="st-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
              <circle cx="17.5" cy="17.5" r="2.5"/>
            </svg>
          </div>
          <p class="st-empty__title">Aucune structure</p>
          <p class="st-empty__hint">Commencez par en ajouter une en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table [columns]="tableStructures" [data]="structures" [actions]="rowActions"/>
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="st-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditTask(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Édition -->
<app-modal
  [isVisible]="showAddStructuresModal"
  [title]="isEditing ? 'Modifier la structure' : 'Nouvelle structure'"
  (closeEvent)="closeAddStructures()"
>
  <form [formGroup]="structureForm" (ngSubmit)="saveStructure()" class="st-form">

    @if (isEditing && editingStructure) {
      <div class="st-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingStructure.libelle }}</strong>
      </div>
    }

    <div class="st-form__field">
      <app-select
        label="Structure Mère"
        formControlName="mere"
        [options]="structuresOptions"
      />
    </div>

    <div class="st-form__field">
      <app-input
        label="Libellé"
        placeholder="Ex : Direction Générale"
        type="text"
        formControlName="libelle"
      />
      @if (structureForm.get('libelle')?.invalid && (structureForm.get('libelle')?.dirty || structureForm.get('libelle')?.touched)) {
        <span class="st-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le libellé est requis.
        </span>
      }
    </div>

    <div class="st-form__field">
      <app-input
        label="Code"
        placeholder="Ex : DG"
        type="text"
        formControlName="code"
      />
      @if (structureForm.get('code')?.invalid && (structureForm.get('code')?.dirty || structureForm.get('code')?.touched)) {
        <span class="st-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le code est requis.
        </span>
      }
    </div>

    <div class="st-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeAddStructures()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || structureForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>